import { http } from '../http';

export interface Combustivel {
  codigo_combustivel: string;
  descricao: string;
  situacao: string;
}

export interface CombustivelResponse {
  total: number;
  page: number;
  limit: number;
  items: Combustivel[];
}

export const fetchSgaCombustiveis = async (
  page: number = 1,
  limit: number = 10
): Promise<CombustivelResponse> => {
  const response = await http.get('/sga-combustivel/listar', {
    params: { page, limit },
  });

  return response.data;
};
